module.exports = __webpack_public_path__ + "img/barcelo-hotel.0b0aefc0.jpg";